import { render, staticRenderFns } from "./OrdersSpreadsheetSubmissionsList.vue?vue&type=template&id=2ebb3e63&"
import script from "./OrdersSpreadsheetSubmissionsList.vue?vue&type=script&lang=js&"
export * from "./OrdersSpreadsheetSubmissionsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports